import { Grid, Typography, Button } from '@mui/material'
import { useState } from 'react'
import { CustomLabelWithToolTip } from '../../../Components/CustomLabel/Index'
import { SearchType } from '../../../core/types'
import { toast } from 'react-toastify'

export interface ServiceProviderOptionsProps {
  isdID: number
  handleBack: () => void
  dataSelected: (type: SearchType) => void
}

export function ServiceProviderOptions (props: ServiceProviderOptionsProps): JSX.Element {
  const [selectedSearchType, setSelectedSearchType] = useState<SearchType | null>(null)

  function handleContinue (): void {
    if (selectedSearchType == null) {
      toast.error('Please select an option to continue')
    } else {
      props.dataSelected(selectedSearchType)
    }
  }

  return <Grid container spacing={2}>
    <Grid item xs={12}>
      <Typography variant='h5' sx={{ mb: '30px' }} component='div' data-testid="service-date-selection-prompt">
        <CustomLabelWithToolTip
          name='IF_Service_Select_Intro'
          isdId={props.isdID ?? 0}
          defaultLabelText='Thank you! Which of the following best describes how you would like to proceed?'
        />
      </Typography>
    </Grid>

    <Grid item xs={12}>
      <Button
        variant="outlined"
        className={'wide-button' + (selectedSearchType === SearchType.Filter ? ' selected' : '')}
        data-testid='search-option-filter'
        onClick={() => { setSelectedSearchType(SearchType.Filter) }}
      >
        I have a service provider in mind
      </Button>
    </Grid>
    <Grid item xs={12}>
      <Button
        variant="outlined"
        className={'wide-button' + (selectedSearchType === SearchType.Map ? ' selected' : '')}
        data-testid='search-option-map'
        onClick={() => { setSelectedSearchType(SearchType.Map) }}
      >
        I would like to browse providers in the area
      </Button>
    </Grid>
    <Grid item xs={12}>
      <Button
        variant="outlined"
        className={'wide-button' + (selectedSearchType === SearchType.ReachOut ? ' selected' : '')}
        data-testid='search-option-reach-out'
        onClick={() => { setSelectedSearchType(SearchType.ReachOut) }}
      >
        I would like someone to reach out to me
      </Button>
    </Grid>

    <Grid item xs={6} sx={{ mb: '20px', mt: '40px' }}>
      <Button
        name='backButton'
        className='back-button'
        data-testid='back-button'
        onClick={props.handleBack}
        variant='outlined'
      >
        Back
      </Button>
    </Grid>
    <Grid item xs={6} sx={{ mb: '20px', mt: '40px' }}>
      <Button
        name='continueButton'
        className='footer-button'
        data-testid='continue-button'
        onClick={handleContinue}
        variant='contained'
      >
        Continue
      </Button>
    </Grid>
  </Grid>
}
